import { render } from "./ClientNotesField.vue?vue&type=template&id=afb7941e&scoped=true"
import script from "./ClientNotesField.vue?vue&type=script&lang=js"
export * from "./ClientNotesField.vue?vue&type=script&lang=js"

import "./ClientNotesField.vue?vue&type=style&index=0&id=afb7941e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb7941e"]])

export default __exports__